import axios from '@/utils/request'
export default {
	states_all: ['newly', 'outed', 'finished', 'canceled'],
	types: ['rent', 'service', 'clean', 'available', 'custom',],

	states_rent_order: ['newly', 'preparing', 'prepared', 'processing', 'received', 'qualitied', 'outed', 'finished', 'reworking', 'canceled', 'returned'],
	// 2020-10-06
	findBySerialNo(params) {
		return axios.get('/weddingDressHall/rent/item/find-by-serial-no', params)
	},
	// 2020-10-06
	insertBatch(params) {
		return axios.post('/weddingDressHall/rent/item/insert-batch', params);
	},
	// 2021-10-06
	delete(id) {
		return axios.delete('/weddingDressHall/rent/item/' + id)
	},
	// 2021-10-06
	update(id, params) {
		return axios.put('/weddingDressHall/rent/item/' + id, params)
	},
	// 2022-05-05
	preparing(id, params) {
		return axios.put('/weddingDressHall/rent/item/' + id + '/preparing', params)
	},
	// 2022-05-05
	prepared(id, params) {
		return axios.put('/weddingDressHall/rent/item/' + id + '/prepared', params)
	},
	// 2021-10-06
	out(id, params) {
		return axios.put('/weddingDressHall/rent/item/' + id + '/out', params)
	},
	// 2021-10-06
	in(id, params) {
		return axios.put('/weddingDressHall/rent/item/' + id + '/in', params)
	},
	// 2021-10-08
	cancel(id, params) {
		return axios.put('/weddingDressHall/rent/item/' + id + '/cancel', params)
	},
	// 2021-11-11
	delivery(id, params) {
		return axios.put('/weddingDressHall/rent/item/' + id + '/delivery', params)
	},
	// 2021-10-10
	searchSchedule(params) {
		return axios.get('/weddingDressHall/rent/item/search-schedule', params);
	},

	// 2022-01-21
	rentedCount() {
		return axios.get('/weddingDressHall/rent/item/rented-count')
	},
	// 2022-01-21
	rentedCountDetail() {
		return axios.get('/weddingDressHall/rent/item/rented-count-detail')
	},

	// 2022-01-21
	crashInfo(params) {
		return axios.get('/weddingDressHall/rent/item/crash-info', params)
	},
	// 2021-10-06
	findById(id) {
		return axios.get('/weddingDressHall/rent/item/' + id);
	}
	// 	// 2021-07-27
	// 	productLifeCycle(params) {
	// 		return axios.get('/weddingDressHall/rent/item/product-life-cycle', params)
	// 	},
}

